import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import { message } from "antd";
import { paymentProvider } from "./paymentProvider";
import { redeemLoyality } from "./loyality";
import i18next from "i18next";
import moment from "moment";
import upsertPOSLog from "../../Retail/posLog";
import { verifyCredit, upsertCreditTransaction } from "../../../../services";
import messages from "../../../../errors/messages.en-IN.json";

export const addAmount = async (
  paymentMethod,
  value,
  grant,
  cart,
  setCart,
  setLoader,
  setPaymentModal,
  setAmount,
  setLoyalityOtpData,
  setLoyalityOtpModalVisible,
  setSelectedPaymentMethod,
  setPaytmQrCodeModalOpens,
  setQrCodeResponse,
  overPayedAmount,
  setShowCardPaymnteModal,
  setCardPaymnetError,
  setCardPaymnetStatus,
  setCardPaymnetStatusPLB,
  setLoading,
  setIsCardPaymentLoading,
  setLayoutType,
  setKioskUI,
  dispatchQRCodeEvent,
  closeQRCodeModal,
  wallet,
  cardPaymentDetails,
  setIntegratedPaymentStatus,
  exchangeCart,
  setExchangeCart,
  processOrder,
  showCustomerWallet,
  handleWalletPostPayment,
  isNewGiftCardFlag,
  showGiftCardTopup,
  handleGiftCardTopupPostPayment
) => {
  const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  const newPaymentAmount = parseFloat(value).toFixed(pricePrecision);
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const t = i18next.t;
  let setAuthTokens;
  let amountAdded;
  const authHeaders = await getOAuthHeaders();
  if (authHeaders && authHeaders.access_token) {
    setAuthTokens = authHeaders.access_token;
  }
  if (cart.payments.length > 0) {
    const currentPaymentsTotal = cart.payments
      .reduce((total, payment) => {
        const paymentAmount = parseFloat(payment.amount);
        return isNaN(paymentAmount) ? total : total + paymentAmount;
      }, 0)
      .toFixed(pricePrecision);

    // Calculate the new total by adding the currentPaymentsTotal and newPaymentAmount
    amountAdded = (parseFloat(currentPaymentsTotal) + parseFloat(newPaymentAmount)).toFixed(pricePrecision);

    // Now, amountAdded contains the sum of amounts in the payments array
  } else {
    amountAdded = parseFloat(value).toFixed(pricePrecision);
  }
  if (grant !== undefined) {
    completePayment(
      paymentMethod,
      value,
      cart,
      setCart,
      setAmount,
      setSelectedPaymentMethod,
      overPayedAmount,
      setLayoutType,
      setKioskUI,
      wallet,
      precision,
      setExchangeCart,
      showCustomerWallet,
      handleWalletPostPayment,
      isNewGiftCardFlag,
      showGiftCardTopup,
      handleGiftCardTopupPostPayment
    );
  } else {
    const validation = RegExp(`^[0-9]+(.[0-9]{1,${pricePrecision}})?$`);
    // let overPaymentFlag = paymentMethod?.name?.toLowerCase() !== "cash" ? cart.paid + parseFloat(value) <= cart.total + overPayedAmount : false;
    let overPaymentFlag = false;

    if (wallet && showCustomerWallet) {
      try {
        const stored = JSON.parse(localStorage.getItem("walletDataForCardIntegration"));

        if (stored) {
          const totalPayments = Number.parseFloat(stored.totalPayments || 0);
          const paymentAmount = Number.parseFloat(value || 0); // 👈 current entered value
          const topupTotal = Number.parseFloat(stored.topupTotal || 0);

          overPaymentFlag = totalPayments + paymentAmount <= topupTotal;
        }
      } catch (e) {
        console.error("walletDataForCardIntegration parse error", e);
        overPaymentFlag = false;
      }
    } else {
      // 👉 existing logic for normal flow
      overPaymentFlag = paymentMethod?.name?.toLowerCase() !== "cash" ? cart.paid + parseFloat(value) <= cart.total + overPayedAmount : false;
    }
    if (paymentMethod !== undefined && paymentMethod !== "" && validation.test(parseFloat(value)) && (parseFloat(value) > 0 || isExchange)) {
      const currentPaymentMethod = paymentMethod;
      if ((currentPaymentMethod.integratedPayment || currentPaymentMethod.integratedPayment === false) && overPaymentFlag) {
        paymentProvider(
          amountAdded,
          currentPaymentMethod,
          paymentMethod,
          value,
          cart,
          setCart,
          setLoader,
          setPaymentModal,
          completePayment,
          setSelectedPaymentMethod,
          setAmount,
          setPaytmQrCodeModalOpens,
          setQrCodeResponse,
          setShowCardPaymnteModal,
          setCardPaymnetError,
          setCardPaymnetStatus,
          setCardPaymnetStatusPLB,
          setLoading,
          setIsCardPaymentLoading,
          setLayoutType,
          setKioskUI,
          dispatchQRCodeEvent,
          closeQRCodeModal,
          wallet,
          cardPaymentDetails,
          setIntegratedPaymentStatus,
          showCustomerWallet,
          handleWalletPostPayment,
          isNewGiftCardFlag,
          showGiftCardTopup,
          handleGiftCardTopupPostPayment
        );
      } else if ((currentPaymentMethod.integratedPayment || currentPaymentMethod.integratedPayment === false) && wallet) {
        paymentProvider(
          amountAdded,
          currentPaymentMethod,
          paymentMethod,
          value,
          cart,
          setCart,
          setLoader,
          setPaymentModal,
          completePayment,
          setSelectedPaymentMethod,
          setAmount,
          setPaytmQrCodeModalOpens,
          setQrCodeResponse,
          setShowCardPaymnteModal,
          setCardPaymnetError,
          setCardPaymnetStatus,
          setCardPaymnetStatusPLB,
          setLoading,
          setIsCardPaymentLoading,
          setLayoutType,
          setKioskUI,
          dispatchQRCodeEvent,
          closeQRCodeModal,
          wallet,
          cardPaymentDetails,
          setIntegratedPaymentStatus,
          showCustomerWallet,
          handleWalletPostPayment,
          isNewGiftCardFlag,
          showGiftCardTopup,
          handleGiftCardTopupPostPayment
        );
      }
      if (currentPaymentMethod.iscredit && overPaymentFlag) {
        cart.advancePayment = cart.advancePayment ? cart.advancePayment : 0;
        const posConfig = JSON.parse(localStorage.getItem("posConfig"));
        if (localStorage.getItem("isCreditSale") === "true" && posConfig?.generateInvoiceForCreditSale !== "Y") {
          processOrder();
          // completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, overPayedAmount, setLayoutType, setKioskUI, wallet, precision, setExchangeCart);
        } else if ((cart.customer.iscredit && value <= cart.total - cart.paid) || (cart.isReturn && cart.customer.iscredit)) {
          setLoader(true);
          setPaymentModal(false);
          try {
            const creditResponse = await verifyCredit(cart.customer.cwrCustomerId, value);
            const { iscredit, creditLimit, creditBalance } = creditResponse.data.data.verifyCredit;
            const verifyCreditMessage = creditResponse.data.data.verifyCredit.message;
            if (iscredit) {
              if (amountAdded > 0 && amountAdded <= creditBalance) {
                const trxData = [
                  {
                    b2cCustomerId: cart.customer.cwrCustomerId,
                    trxDate: moment(new Date()).format("YYYY-MM-DD"),
                    trxAmt: Number(value),
                    openingAmt: cart?.customer?.creditBalance,
                    closingAmt: creditBalance,
                    type: "DR",
                    cwrTillId: null,
                    sOrderId: null,
                    referenceNo: cart?.referenceId,
                  },
                ];
                const creditUpsertResponse = await upsertCreditTransaction(trxData);
                if (creditUpsertResponse?.data?.data?.upsertCreditTransaction?.status === "200") {
                  message.success(`${t(verifyCreditMessage)}`);
                  completePayment(
                    paymentMethod,
                    value,
                    cart,
                    setCart,
                    setAmount,
                    setSelectedPaymentMethod,
                    overPayedAmount,
                    setLayoutType,
                    setKioskUI,
                    wallet,
                    precision,
                    setExchangeCart,
                    showCustomerWallet,
                    handleWalletPostPayment,
                    isNewGiftCardFlag,
                    showGiftCardTopup,
                    handleGiftCardTopupPostPayment
                  );
                }
              } else {
                {
                  message.warning(`${t("credit_payment_less_amount_error")}`);
                }
              }
            } else {
              message.warning(`${messages.errors.payments.eligible_customer}`);
            }
          } catch (err) {
            console.error(err);
            message.error(`${messages.info.payment_failed}!`);
          } finally {
            setLoader(false);
            if (tillLayout === 2) {
              setPaymentModal(true);
            }
          }
        } else {
          {
            message.warning(`${t("credit payment is can not be more than sale amount")}`);
          }
        }
      } else if (currentPaymentMethod.isloyalty && overPaymentFlag) {
        setLoader(true);
        redeemLoyality(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, setAuthTokens, completePayment);
        // setPaymentModal(false);
      } else if (currentPaymentMethod.isGiftCard && overPaymentFlag) {
        completePayment(
          paymentMethod,
          value,
          cart,
          setCart,
          setAmount,
          setSelectedPaymentMethod,
          overPayedAmount,
          setLayoutType,
          setKioskUI,
          wallet,
          precision,
          setExchangeCart,
          showCustomerWallet,
          handleWalletPostPayment,
          isNewGiftCardFlag,
          showGiftCardTopup,
          handleGiftCardTopupPostPayment
        );
      } else if (
        currentPaymentMethod?.name?.toLowerCase() === "cash" ||
        (currentPaymentMethod.integratedPayment === false && currentPaymentMethod.paymentProvider === null) ||
        currentPaymentMethod?.isBankTransfer === "Y"
      ) {
        completePayment(
          paymentMethod,
          value,
          cart,
          setCart,
          setAmount,
          setSelectedPaymentMethod,
          overPayedAmount,
          setLayoutType,
          setKioskUI,
          wallet,
          precision,
          setExchangeCart,
          showCustomerWallet,
          handleWalletPostPayment,
          isNewGiftCardFlag,
          showGiftCardTopup,
          handleGiftCardTopupPostPayment
        );
      } else if (
        currentPaymentMethod.integratedPayment === false &&
        currentPaymentMethod.paymentProvider === "ADC"
        // || (currentPaymentMethod.integratedPayment === false && currentPaymentMethod.paymentProvider === null)
      ) {
        setShowCardPaymnteModal(true);
        setCardPaymnetError(true);
        setCardPaymnetStatus({
          paymentStatus: false,
          message: "",
          paymentMode: "",
        });
      } else if (!overPaymentFlag && !(isNewGiftCardFlag && showGiftCardTopup)) {
        console.log("Overpayment attempt detected");
        message.warn(`${messages.errors.cart.overpayment_not_allowed}`);
      }
    }
  }
};

export const completePayment = (
  paymentMethod,
  value,
  cart,
  setCart,
  setAmount,
  setSelectedPaymentMethod,
  overPayedAmount,
  setLayoutType,
  setKioskUI,
  wallet,
  precision,
  setExchangeCart,
  showCustomerWallet,
  handleWalletPostPayment,
  isNewGiftCardFlag,
  showGiftCardTopup,
  handleGiftCardTopupPostPayment
) => {
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const isExchange = localStorage.getItem("selectedReturnType") === "EXCHANGE";
  const cartObj = JSON.parse(localStorage.getItem("cartObj")) || {};
  const exchangeCartObj = JSON.parse(localStorage.getItem("exchangeCartObj")) || {};
  let activeCart = isExchange ? exchangeCartObj : cartObj;
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const cardDetails = localStorage.getItem("cardPaymentDetails") ? JSON.parse(localStorage.getItem("cardPaymentDetails")) : {};
  let netAmountToPay = activeCart.total;
  if (isExchange) {
    const updatedCartObj = { ...cartObj };

    const returnPayment = {
      ...paymentMethod,
      amount: parseFloat(cartObj.total || 0).toFixed(pricePrecision),
    };

    updatedCartObj.payments = [returnPayment];

    // updatedCartObj.paid = Math.abs(parseFloat(cartObj.total || 0));
    setCart(updatedCartObj);
    localStorage.setItem("cartObj", JSON.stringify(updatedCartObj));
  }
  if (isExchange) {
    const returnTotal = cartObj.total || 0;
    const exchangeTotal = exchangeCartObj.total || 0;
    netAmountToPay = exchangeTotal + returnTotal;
  }
  if (wallet === true) {
    const amountAdded = parseFloat(value);
    const currentPaymentMethod = paymentMethod;
    let walletPayments = [];
    try {
      const storedPayments = JSON.parse(localStorage.getItem("walletPayments"));
      // Ensure walletPayments is an array
      walletPayments = Array.isArray(storedPayments) ? storedPayments : [];
    } catch (e) {
      console.error("Error parsing walletPayments from localStorage:", e);
      // If JSON.parse fails or stored data is invalid, keep walletPayments as an empty array
      walletPayments = [];
    }

    // Check if paymentMethod.name matches any walletPayments.name
    const matchingPaymentIndex = walletPayments.findIndex((wp) => wp.finPaymentmethodID === paymentMethod.finPaymentmethodId);

    if (matchingPaymentIndex >= 0) {
      const existing = walletPayments[matchingPaymentIndex];
      // If fin-nilPaymentmethodID matches, add the amount to the existing wallet payment
      walletPayments[matchingPaymentIndex].amount = parseFloat((parseFloat(walletPayments[matchingPaymentIndex].amount) + parseFloat(amountAdded)).toFixed(pricePrecision));
      walletPayments[matchingPaymentIndex].count = (existing.count || 1) + 1;
      // Update card details if the payment method is card
      if (currentPaymentMethod.name.toLowerCase() === "card") {
        walletPayments[matchingPaymentIndex] = {
          ...walletPayments[matchingPaymentIndex],
          transactionId: cardDetails?.transactionId || walletPayments[matchingPaymentIndex].transactionId,
          cardType: cardDetails?.cardType || walletPayments[matchingPaymentIndex].cardType,
          cardNo: cardDetails?.cardNumber || walletPayments[matchingPaymentIndex].cardNo,
          transactionTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          authorizationCode: cardDetails?.authorization || walletPayments[matchingPaymentIndex].authorizationCode,
          metaData: walletPayments[matchingPaymentIndex].metaData || [],
          count: walletPayments[matchingPaymentIndex].count || 1,
        };
      }
    } else {
      // If finPaymentmethodID doesn't match, add new payment method with amount
      currentPaymentMethod.amount = parseFloat(amountAdded).toFixed(pricePrecision);
      if (currentPaymentMethod.name.toLowerCase() === "card") {
        if (currentPaymentMethod.integratedPayment === true) {
          walletPayments.push({
            finPaymentmethodID: currentPaymentMethod.finPaymentmethodId,
            amount: parseFloat(parseFloat(currentPaymentMethod.amount)?.toFixed(precision)) || value,
            transactionResponse: "",
            transactionId: cardDetails?.transactionId || null,
            cardType: cardDetails?.cardType || "",
            cardNo: cardDetails?.cardNumber || "",
            transactionTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            authorizationCode: cardDetails?.authorization || null,
            metaData: [],
            count: 1,
          });
        } else {
          walletPayments.push({
            finPaymentmethodID: currentPaymentMethod.finPaymentmethodId,
            amount: parseFloat(parseFloat(currentPaymentMethod.amount)?.toFixed(precision)) || value,
            transactionResponse: null,
            transactionId: cardDetails?.transactionId || null,
            cardType: cardDetails?.cardType || null,
            cardNo: cardDetails?.cardNumber || null,
            transactionTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            authorizationCode: cardDetails?.authorization || null,
            metaData: [],
            count: 1,
          });
        }
      } else {
        walletPayments.push({
          finPaymentmethodID: currentPaymentMethod.finPaymentmethodId,
          amount: parseFloat(parseFloat(currentPaymentMethod.amount)?.toFixed(precision)) || value,
          count: 1,
          ...(currentPaymentMethod?.isBankTransfer === "Y" && {
            isBankTransfer: "Y",
            financialAccountId: currentPaymentMethod?.financialAccount || null,
            transactionId: currentPaymentMethod?.transactionId || null,
            transactionTime: currentPaymentMethod?.transactionDate ? moment(currentPaymentMethod?.transactionDate).format("YYYY-MM-DD HH:mm:ss") : null,
            imageUrl: currentPaymentMethod?.financialFile || null,
          }),
        });
      }
    }
    localStorage.setItem("walletPayments", JSON.stringify(walletPayments));
    if (currentPaymentMethod.name.toLowerCase() === "card" || currentPaymentMethod.name.toLowerCase() === "upi") {
      if (wallet && showCustomerWallet) {
        handleWalletPostPayment();
      } else if (isNewGiftCardFlag && showGiftCardTopup) {
        handleGiftCardTopupPostPayment();
      }
    }
  } else {
    // ... (rest of the original else branch remains unchanged)
    if (
      Number(Math.abs(activeCart.paid + parseFloat(value)).toFixed(pricePrecision)) > Number(Math.abs(netAmountToPay + overPayedAmount).toFixed(pricePrecision)) &&
      paymentMethod?.name?.toLowerCase() !== "cash" &&
      paymentMethod.roundOffForPos === "N" &&
      paymentMethod?.integratedPayment === false
    ) {
      console.log("Overpayment attempt detected");
      message.warn(`${messages.errors.cart.overpayment_not_allowed}`);
      return;
    }
    const paymentAddons = activeCart.payments;
    const amountAdded = parseFloat(value);
    if (activeCart?.cardPaymentData?.manual) {
      paymentMethod = { ...paymentMethod, ...activeCart?.cardPaymentData?.manual };
    }
    const currentPaymentMethod = paymentMethod;
    let shouldRemoveRedeemPoints = false;

    if (paymentMethod.isloyalty && amountAdded < 0) {
      shouldRemoveRedeemPoints = true;
    }

    const index = paymentAddons.findIndex((p) => p.finPaymentmethodId === currentPaymentMethod.finPaymentmethodId);
    const cardPaymentFlag = activeCart.payments.some((p) => p.authorization === paymentMethod?.authorization);
    if (index >= 0 && (paymentMethod?.name?.toLowerCase() === "card" ? cardPaymentFlag : true)) {
      const newAmount = parseFloat(paymentAddons[index].amount) + parseFloat(amountAdded);
      activeCart.advancePayment = activeCart.advancePayment ? activeCart.advancePayment : 0;
      let paidAmount = activeCart.paid + parseFloat(amountAdded);
      paymentAddons[index].amount = parseFloat(newAmount).toFixed(pricePrecision);
      if (paidAmount - Math.abs(netAmountToPay) > 0) {
        paymentAddons[index].amount = paymentAddons[index].amount - (paidAmount - Math.abs(netAmountToPay));
        // cart.change = parseFloat(parseFloat(paidAmount - Math.abs(cart.total + parseFloat(overPayedAmount))).toFixed(pricePrecision));
        activeCart.change = parseFloat(
          parseFloat(paidAmount - Math.abs(Math.abs(netAmountToPay) + (posConfig?.enableChangeRounding === "Y" ? parseFloat(overPayedAmount) : 0))).toFixed(pricePrecision)
        );
      }
    } else {
      if (amountAdded !== 0) {
        activeCart.advancePayment = activeCart.advancePayment ? activeCart.advancePayment : 0;
        let paidAmount = activeCart.paid + parseFloat(amountAdded);
        currentPaymentMethod.amount = parseFloat(amountAdded).toFixed(pricePrecision);
        if (paidAmount - Math.abs(netAmountToPay) > 0) {
          currentPaymentMethod.amount = parseFloat(amountAdded).toFixed(pricePrecision) - (paidAmount - Math.abs(activeCart.total));
          // cart.change = parseFloat(parseFloat(paidAmount - Math.abs(cart.total + parseFloat(overPayedAmount))).toFixed(pricePrecision));
          activeCart.change = parseFloat(
            parseFloat(paidAmount - Math.abs(Math.abs(netAmountToPay) + (posConfig?.enableChangeRounding === "Y" ? parseFloat(overPayedAmount) : 0))).toFixed(pricePrecision)
          );
        }
        paymentAddons.push(currentPaymentMethod);
      }
    }

    let totalAmountAdded = 0;
    const paymentMethodsCount = paymentAddons.length;
    for (let i = 0; i < paymentMethodsCount; i += 1) {
      totalAmountAdded += parseFloat(paymentAddons[i].amount);
    }

    if (paymentMethod.redemptionPoints) {
      activeCart.redemptionPoints = paymentMethod.redemptionPoints;
    }

    const redemptionPts = shouldRemoveRedeemPoints ? 0 : activeCart.redemptionPoints;

    let creditAmountValue = activeCart.creditAmount;
    if (paymentMethod.iscredit && amountAdded > 0) {
      if (activeCart.creditAmount > 0) {
        creditAmountValue = activeCart.creditAmount + amountAdded;
      } else {
        creditAmountValue = amountAdded;
      }
    }

    if (paymentMethod.iscredit && amountAdded < 0) {
      creditAmountValue = 0;
    }
    if (!isExchange) {
      activeCart.total = parseFloat(activeCart.total.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
    }
    if (currentPaymentMethod?.name?.toLowerCase() === "cash") {
      activeCart.tenderedAmount = +value + (+activeCart.tenderedAmount || 0);
    }

    const finalCartObj = {
      ...activeCart,
      paid: parseFloat(parseFloat(totalAmountAdded + activeCart.advancePayment).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)),
      payments: [...paymentAddons],
      redemptionPoints: redemptionPts,
      creditAmount: creditAmountValue,
      ...(isExchange && { netAmountToPay: parseFloat(netAmountToPay.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)) }),
    };

    let orderTimeDetails = JSON.parse(localStorage.getItem("orderTimeDetails"))
      ? JSON.parse(localStorage.getItem("orderTimeDetails"))
      : { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    if (orderTimeDetails.paymentStartTime === "") {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
    }

    localStorage.setItem("orderTimeDetails", JSON.stringify(orderTimeDetails));
    if (isExchange) {
      setExchangeCart(finalCartObj);
      localStorage.setItem("exchangeCartObj", JSON.stringify(finalCartObj));
    } else {
      setCart(finalCartObj);
      localStorage.setItem("cartObj", JSON.stringify(finalCartObj));
    }
    setSelectedPaymentMethod("");
    // setAmount(
    //   Math.abs(activeCart.total) > Math.abs(totalAmountAdded) + activeCart.advancePayment
    //     ? parseFloat(Math.abs(activeCart.total) - (Math.abs(totalAmountAdded) + activeCart.advancePayment)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)
    //     : ""
    // );
    setAmount(
      Math.abs(netAmountToPay) > Math.abs(totalAmountAdded) + activeCart.advancePayment
        ? parseFloat(Math.abs(netAmountToPay) - (Math.abs(totalAmountAdded) + activeCart.advancePayment)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)
        : ""
    );
    upsertPOSLog(finalCartObj, "PAY");
    const userAccessController = JSON.parse(tillData?.tillAccess?.userAccessController || {});
    const layout = userAccessController.layout;
    if (layout === "3") {
      setLayoutType(7);
      localStorage.setItem("layoutType", 7);
      const customEvent1 = new CustomEvent("customStorageChange", {
        detail: { key: "layoutType", newValue: 7 },
      });
      window.dispatchEvent(customEvent1);
      setKioskUI(5);
      const customEvent = new CustomEvent("customStorageChange", {
        detail: { key: "kioskUI", newValue: 5 },
      });
      window.dispatchEvent(customEvent);
      localStorage.setItem("kioskUI", 5);

      setTimeout(() => {
        localStorage.setItem("kioskUI", 0);
        setKioskUI(0);
        const customEvent = new CustomEvent("customStorageChange", {
          detail: { key: "kioskUI", newValue: 0 },
        });
        window.dispatchEvent(customEvent);

        localStorage.setItem("layoutType", 0);
        setLayoutType(0);
        const customEvent1 = new CustomEvent("customStorageChange", {
          detail: { key: "layoutType", newValue: 0 },
        });
        window.dispatchEvent(customEvent1);
      }, 5000);
    }
  }
};
